import { render, staticRenderFns } from "./BorderBox1.vue?vue&type=template&id=5da3384b"
import script from "./BorderBox1.vue?vue&type=script&lang=js"
export * from "./BorderBox1.vue?vue&type=script&lang=js"
import style0 from "./BorderBox1.vue?vue&type=style&index=0&id=5da3384b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports